import { ShoppingBag, SportsMotorsports } from "@mui/icons-material";

import AddressLine from "../web_pages/RestaurantPage/RestDetails/addressLine";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import parse from 'html-react-parser';




const getOrderTotalPrice = (theOrder) => {

    let tot = 0;

    tot = getOrderPrice(theOrder);

    //משלוח - parseFloat כדי לשמור אגורות (למשל 15.90)
    if (theOrder.OrderType == "Deliver") {
        tot += parseFloat(theOrder.OrderDelPrice);
    }

    //קופון
    if (theOrder.orderKopon && theOrder.orderKopon !== "") {

        // KoponDiscType==='1' - הנחה בסכום קבוע (parseFloat, אגורות מלאות).
        // אחרת - הנחה באחוזים: מעגלים את סכום ההנחה כלפי מטה (Math.floor)
        // כדי שהעיגול תמיד לטובת העסק. KoponDiscount עצמו נשאר parseFloat מדויק.
        let koponPrice = (theOrder.orderKopon.KoponDiscType === '1')
            ? parseFloat(theOrder.orderKopon.KoponDiscount) * -1
            : Math.floor((getOrderPrice(theOrder) / 100) * parseFloat(theOrder.orderKopon.KoponDiscount)) * -1

        tot += parseFloat(koponPrice);
    }

    //זיכויים - parseFloat כדי לשמור אגורות
    if (theOrder.orderZikoy && theOrder.orderZikoy.length > 0) {
        theOrder.orderZikoy.forEach(element => {
            let zikoyPrice = parseFloat(element.zickoyPrice) * -1;
            tot += parseFloat(zikoyPrice);
        });
    }

    // קרדיטים אינם הנחה אלא אמצעי תשלום — הם לא מנוכים מסכום ההזמנה.
    // סכום ההזמנה הוא מה שהעסק זכאי לו; החלק שמכוסה בקרדיטים משולם ע"י אשדוד בתפריט.
    // לסכום שהלקוח צריך לשלם בפועל יש getOrderToPay למטה.

    return tot;
}


// כמה הלקוח משלם בפועל: סכום ההזמנה פחות הקרדיטים שניצל.
// ההפרש מתקזז מול אשדוד בתפריט ולא נגבה מהלקוח.
const getOrderToPay = (theOrder) => {
    let tot = getOrderTotalPrice(theOrder);

    const creditsUsed = parseInt(theOrder.creditsUsed) || 0;
    if (creditsUsed > 0) {
        tot -= creditsUsed;
        if (tot < 0) tot = 0;
    }

    return tot;
}


const getOrderPrice = (theOrder) => {
    let tot = 0;

    theOrder.Orders.map((item, index) => {
        let addsPrice = 0;
        let itemPrice = 0;

        // בדיקה אם זה מוצר קומבו - אם יש addsPrice מוגדר, זה אומר שהמחיר כבר חושב
        if (item.addsPrice !== undefined && item.addsPrice !== null) {
            addsPrice = parseFloat(item.addsPrice);
        }
        // רק אם זה לא קומבו - בודק תוספות רגילות
        else if (item.specials && item.specials.length > 0) {
            item.specials.map((special, specialIndex) => {
                if (special.splitSelection != true) {
                    let freeCount = 0;

                    //בודק אם יש חינמים
                    special.spec.map((spec, specIndex) => {

                        if (special.freeAdds && parseInt(special.freeAdds) > 0) {

                            for (let i = 0; i < spec.itmsMount; i++) {
                                freeCount++;
                                if (freeCount <= parseInt(special.freeAdds)) {

                                }
                                else {
                                    if (parseFloat(spec.addToPrice) > -1) {
                                        addsPrice += (parseFloat(spec.addToPrice))
                                    }
                                }
                            }

                        }
                        else {
                            for (let i = 0; i < spec.itmsMount; i++) {
                                if (parseFloat(spec.addToPrice) > -1) {
                                    addsPrice += (parseFloat(spec.addToPrice))
                                }
                            }
                        }
                    })
                }
                else {
                    addsPrice += getPizzaAddonsPrice(special, 0);
                }
            })

        }

        // **חישוב למוצרים עם משקל**
        if (item.weightValue !== undefined && item.weightValue !== null) {
            // המרה מגרמים לק"ג
            const weightInKg = parseFloat(item.weightValue) / 1000;
            // מחיר למוצר = מחיר בסיס * משקל בק"ג
            itemPrice = parseFloat(item.prodPrice) * weightInKg;
        } else {
            // מוצר רגיל - מחיר בסיס * כמות
            itemPrice = parseFloat(item.prodPrice) * parseInt(item.mount);
        }

        // חישוב סופי: מחיר מוצר + (תוספות * כמות)
        tot += itemPrice + (addsPrice * parseInt(item.mount));

    })
    tot += parseFloat(getStickedSauces(theOrder));

    return tot;
}

const getPizzaAddonsPrice = (special, addsPrice) => {

    let freeCount = 0; // Tracks the number of free items allocated
    let freeAdds = special.freeAdds ? special.freeAdds : 0

    // Separate full items
    let theFulls = special.spec.filter(it =>
        it.splitSelected == null ||
        it.splitSelected == "" ||
        it.splitSelected == "full"
    );

    // Separate split items
    let theSpls = special.spec.filter(it =>
        it.splitSelected != null &&
        it.splitSelected != "" &&
        it.splitSelected != "full"
    );

    // Process the fulls
    for (let i = 0; i < theFulls.length; i++) {
        freeCount++;
        if (freeCount > parseInt(freeAdds)) {
            addsPrice += parseFloat(theFulls[i].addToPrice); // Add price, rounded up
        }
    }

    // Check if freeCount is still within the limit after processing fulls
    if (freeCount < parseFloat(freeAdds)) {
        for (let i = 0; i < theSpls.length; i++) {
            freeCount += 0.5;

            if (freeCount > parseFloat(freeAdds)) {
                addsPrice += parseFloat(theSpls[i].addToPrice); // Add price, rounded up
            }
        }
    }
    else {
        for (let i = 0; i < theSpls.length; i++) {

            addsPrice += parseFloat(theSpls[i].addToPrice);
        }

    }

    return (addsPrice = Math.ceil(parseFloat(addsPrice)))
}


//בדיקת חינמים
const getPriceAfterFree = (freeAdds, fullsSelc, defaultprice) => {

    let priceAfterFix = defaultprice;

    if (fullsSelc / 2 <= freeAdds) {
        priceAfterFix = 0;
    }
    return (priceAfterFix)
}

// בדיקת חינמים בפיצה
const getPizzaPriceAfterFree = (theLst, theItem) => {

    //כמה שלמים
    let theFulls = theLst.filter(it =>
        it.splitSelected == null ||
        it.splitSelected == "" ||
        it.splitSelected == "full")

    //כמה חצויים
    let theSpls = theLst.filter(it =>
        it.splitSelected != null &&
        it.splitSelected != "" &&
        it.splitSelected != "full")

    //ריצה על כל השלמים
    for (let j = 0; j < theFulls.length; j++) {
        const element = theFulls[j];
        let sourcePrice = theItem.options.find((it, index) => it.servType == element.servType).addToPrice
        let theIndx = theLst.findIndex(ind => ind.servType == theFulls[j].servType)
        theLst[theIndx].addToPrice = sourcePrice.toString()
    }


    //ריצה על כל החצויים
    if (theSpls.length > 0 && theSpls.length % 2 == 0) {
        for (let i = 0; i < theSpls.length; i++) {
            let theIndx = theLst.findIndex(ind => ind.servType == theSpls[i].servType)
            let sourcePrice = theItem.options.find((it, index) => it.servType == theSpls[i].servType).addToPrice

            theLst[theIndx].addToPrice = (sourcePrice / 2).toString()
            //   theLst[theIndx].addToPrice = sourcePrice.toString()

        }

    }
    else if (theSpls.length > 0) {
        if (theSpls.length == 1) {
            let theIndx2 = theLst.findIndex(ind => ind.servType == theSpls[0].servType)
            let sourcePrice2 = theItem.options.find((it, index) => it.servType == theSpls[0].servType).addToPrice
            theLst[theIndx2].addToPrice = sourcePrice2.toString()
        }
        else {
            for (let i = 0; i < theSpls.length - 1; i++) {
                let theIndx = theLst.findIndex(ind => ind.servType == theSpls[i].servType)
                let sourcePrice = theItem.options.find((it, index) => it.servType == theSpls[i].servType).addToPrice

                theLst[theIndx].addToPrice = (sourcePrice / 2).toString()
                //   theLst[theIndx].addToPrice = sourcePrice.toString()

            }


            let theIndx2 = theLst.findIndex(ind => ind.servType == theSpls[theSpls.length - 1].servType)
            let sourcePrice2 = theItem.options.find((it, index) => it.servType == theSpls[theSpls.length - 1].servType).addToPrice
            theLst[theIndx2].addToPrice = sourcePrice2.toString()
        }

    }

    return (theLst)
}



const takeAwayBlock = (theTime, Address, futureOrderBlock, mobiOrNot, isFutureOrder) => {

    //בהזמנה עתידית: שורת "הזמנה עתידית..." קודם, ואז שורת האייקון+"איסוף
    //עצמי" מתחתיה. בהזמנה רגילה לעכשיו (isFutureOrder=false) מוצג במקום זה
    //טקסט זמן האיסוף המוערך (theTime), אותו רעיון כמו deliveryBlock - זהה
    //במובייל ובדסקטופ (ראו deliveryBlock, אותו pattern בדיוק)
    return (
        <div className={"takeAwayBlock futureMobiOrder"}>
            {isFutureOrder && futureOrderBlock &&
                <div className={"futureOrderBlockLine"}>
                    {futureOrderBlock}
                </div>
            }
            <div className={"theImg pickOrDel"}>
                <ShoppingBag />
                <span className={"bold"}>איסוף עצמי</span>
            </div>


            <div className={"clearFloat overflowHid"}>
                <div style={{ display: "table", margin: "0 auto" }}>
                    <div className={"big onRight spaceRight bold clearBack"} >{!isFutureOrder ? theTime : futureOrderBlock}</div>
                </div>
            </div>
        </div>
    )
}


//גרסת הכרטיס בפופאפ בחירת סוג הזמנה (OrderTypeSelect, ORDTYLine) - הפריסה
//הבסיסית של .theImg/.txtOrdType הצפה זה לצד זה, בלי .futureMobiOrder/flex
//שמיועדים לגוש הסיכום ב-TheOrderList. אותו pattern כמו deliveryBlock2
const takeAwayBlock2 = (theTime, Address) => {
    return (
        <>
            <div className={"takeAwayBlock"}>
                <div className={"theImg"}>
                    <ShoppingBag />
                </div>
                <div className={"txtOrdType"}>

                    <div className={"bold pickOrDel"} >איסוף עצמי</div>
                    <div className={"regular"} >{theTime}</div>

                </div>


            </div>
        </>
    )
}


const deliveryBlock2 = (theTime, Address) => {
    return (
        <>
            <div className={"takeAwayBlock"}>
                <div className={"theImg"}>
                    <SportsMotorsports />
                </div>
                {/* <div className={"theImg"} style={{ backgroundImage: `url("/PermanentImages/take.png")` }}></div> */}
                <div className={"txtOrdType"}>

                    <div className={"bold pickOrDel"} >משלוח</div>
                    <div className={"regular"} >{theTime}</div>
                    {/* <div className={"regular"} ><AddressLine address={Address} typeDisp="NoIcon" /></div> */}

                </div>


            </div>
        </>
    )
}


const deliveryBlock = (theTime, currentPage, deliveryAddress, futureOrderBlock, mobiOrNot, isFutureOrder) => {

    let delPrice = 0;
    if (deliveryAddress?.deliveryPrice) {
        delPrice = deliveryAddress.deliveryPrice;
    }
    else if (currentPage) {
        if (currentPage.cityesToDeliver) {
            delPrice = currentPage.cityesToDeliver[0]?.deliveryPrice || 0
        }
    }
    if (delPrice) {
        const channelLine =
            <><div className={"theImg pickOrDel"}>
                <SportsMotorsports />
                <div>
                    <div className={"bold"}>משלוח</div>
                </div>
            </div>

            </>

        const addressBlock = deliveryAddress &&
            <div className={`${isFutureOrder ? "clearFloat overflowHid" : ""}`}>
                <div style={{ display: "table", margin: "0 auto" }}>
                    <div className={"big onRight spaceRight bold"} >{deliveryAddress.street}</div>
                    <div className={"big onRight spaceRight bold"} >{deliveryAddress.num}</div>
                    {deliveryAddress.appartment && <><div className={"big onRight spaceRight bold"} >דירה: {deliveryAddress.appartment}</div></>}
                    {deliveryAddress.ent && <> <div className={"big onRight spaceRight bold"} >כניסה {deliveryAddress.ent}</div></>}
                    {deliveryAddress.flor && <> <div className={"big onRight spaceRight bold"} >קומה {deliveryAddress.flor}</div></>}
                    <div className={"big onRight spaceRight bold"} >{deliveryAddress.city}</div>
                    {deliveryAddress.remarks && <> <div className={"big onRight spaceRight bold"} >קוד בכניסה {deliveryAddress.entryCode}</div></>}
                </div>
            </div>;

        //במובייל: בהזמנה עתידית שורת "הזמנה עתידית..." קודם, ואז אייקון+"משלוח".
        //בהזמנה רגילה לעכשיו - אייקון+"משלוח", כתובת, ואז טקסט זמן הגעה מוערך
        //(theTime) במקום שורת ההזמנה העתידית
        // if (mobiOrNot) {
        return (
            <div className={"takeAwayBlock futureMobiOrder"}>
                {isFutureOrder && futureOrderBlock &&
                    <div className={"futureOrderBlockLine"}>
                        {futureOrderBlock}
                    </div>
                }
                {channelLine}
                {addressBlock}
                <div className={"spaceTop clearFloat overflowHid clearBack"}>
                    <div className={"spaceTop centerText"}>
                        {isFutureOrder ? futureOrderBlock : theTime}
                    </div>
                </div>
                <div className={" spaceTop clearFloat overflowHid"}>
                    <div className={"spaceTop"}>
                        <div className={"bFont bold centerText"} >מחיר משלוח:  ₪{delPrice}</div>
                    </div>
                </div>

            </div>
        )
        // }

        // return (
        //     <>
        //         <div className={"takeAwayBlock"}>
        //             <div className={"theImg"}>
        //                 <SportsMotorsports />
        //             </div>
        //             <div className={"bold pickOrDel"} >משלוח</div>
        //             {futureOrderBlock &&
        //                 <div className={"txtOrdType futureOrderBlockLine"}>
        //                     {futureOrderBlock}
        //                 </div>
        //             }
        //             {addressBlock}
        //             <div className={"txtOrdType"}>

        //                 <div className={"regular"} >{`${isFutureOrder ? futureOrderBlock : <div className={"futureOrderTimeMobi"}>theTime</div>}`}</div>
        //                 <div className={"regular"} >מחיר משלוח:  ₪{delPrice}</div>

        //             </div>


        //         </div >
        //     </>
        // )
    }
}

const theItemSpecials = (item) => {

    let totBk = (item.specials.length > 0) ?
        item.specials.map((special, specialIndex) => {

            let specCount = 0;
            let freeCount = 0;

            // בדיקה אם זה מוצר קומבו - אם יש spec עם prodName, זה קומבו
            if (special.spec && special.spec.length > 0 && special.spec[0].prodName) {
                // זה קומבו - צריך להציג מוצרים עם התוספות שלהם
                return (
                    <div key={specialIndex} className={"ordItmSpecLine spacePadSmall"}>
                        <div className={"ordItmOptHead spacePadSmall bold"}>{special.optionName}</div>
                        {special.spec.map((product, productIndex) => (
                            <div key={productIndex} style={{ marginRight: '10px' }}>
                                <div className={"ordItmLine ordItmOptHead"}>
                                    <span className={"rSideMiddle"}>
                                        {(product.itmsMount && product.itmsMount > 1) && (
                                            <span className={"bold spacePadLeft"}>{product.itmsMount} יח'</span>
                                        )}
                                        <span className={"regular"}>{product.prodName}</span>
                                    </span>
                                    {product.prodPrice > 0 && (
                                        <span className={"bold lSideSmall"}>₪ {product.prodPrice * (product.itmsMount || 1)} +</span>
                                    )}
                                </div>

                                {/* תוספות של המוצר */}
                                {product.specials && product.specials.length > 0 && (
                                    <div style={{ marginRight: '20px' }}>
                                        {product.specials.map((prodSpecial, prodSpecialIndex) => {
                                            const freeAdds = parseInt(prodSpecial.freeAdds || 0);
                                            const sortedSpec = [...(prodSpecial.spec || [])].sort((a, b) =>
                                                (parseInt(b.addToPrice || 0) * parseInt(b.itmsMount || 1)) -
                                                (parseInt(a.addToPrice || 0) * parseInt(a.itmsMount || 1))
                                            );
                                            const toCharge = Math.max(0, sortedSpec.length - freeAdds);
                                            const chargedPrice = sortedSpec.slice(0, toCharge).reduce((sum, s) =>
                                                sum + (parseInt(s.addToPrice || 0) * parseInt(s.itmsMount || 1)), 0
                                            );
                                            return (
                                                <div key={prodSpecialIndex} style={{ marginBottom: '5px' }}>
                                                    <div className={"ordItmLine ordItmOptHead small bold"} style={{ fontSize: '13px' }}>
                                                        <span>{prodSpecial.optionName}:</span>
                                                        {chargedPrice > 0 && (
                                                            <span className={"bold lSideSmall"}>₪ {chargedPrice} +</span>
                                                        )}
                                                    </div>
                                                    {prodSpecial.spec && prodSpecial.spec.map((spec, specIdx) => (
                                                        <div key={specIdx} className={"ordItmLine"} style={{ fontSize: '13px' }}>
                                                            <span className={"ordItmOptHead regular"}>
                                                                {spec.servType || spec.prodName}
                                                                {spec.itmsMount > 1 && ` X${spec.itmsMount}`}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                );
            }
            // מוצר רגיל (לא קומבו)
            else if (!special.splitSelection || special.splitSelection == "full") {
                let specc = special.spec.map((spec, specIndex) => {
                    let addsPrice = 0;

                    if (spec.addToPrice > -1) {
                        specCount++;
                        //בודק אם יש חינמים
                        if (special.freeAdds != null && parseInt(special.freeAdds) > 0) {
                            for (let i = 0; i < spec.itmsMount; i++) {
                                freeCount++;
                                if (freeCount <= parseInt(special.freeAdds)) {
                                }
                                else {
                                    if (parseFloat(spec.addToPrice) > -1) {
                                        addsPrice += parseFloat(spec.addToPrice)
                                    }
                                }
                            }
                        }
                        else {
                            for (let i = 0; i < spec.itmsMount; i++) {
                                if (parseFloat(spec.addToPrice) > -1) {
                                    addsPrice += (parseFloat(spec.addToPrice))
                                }
                            }
                        }


                        return (
                            <div key={specIndex} className={"ordItmLine ordItmOptHead"}>
                                <span className={"rSideMiddle"}>
                                    {(spec.itmsMount && spec.itmsMount > 1) && (
                                        <span className={"bold spacePadLeft"}>{spec.itmsMount} יח'</span>
                                    )}
                                    <span className={"regular"}> {spec.servType}</span>
                                    <span className={"bold"}>
                                        {item.mount > 1 ? `  (* ${item.mount})` : ""}
                                    </span>
                                </span>

                                <span className={"bold lSideSmall"}>
                                    {addsPrice > 0 ? "₪ " + (addsPrice * parseInt(item.mount)) + " +" : ""}
                                </span>
                            </div>
                        )
                    }
                })
                if (specCount > 0) {
                    return (
                        <div key={specialIndex} className={"ordItmSpecLine spacePadSmall"}>
                            <div className={"ordItmOptHead spacePadSmall bold"} >{special.optionName}</div>
                            {specc}
                        </div>
                    )
                }
            }
            else {
                return (
                    <div key={"pizz1"} className={"ordItmLine ordItmOptHead"}>
                        <span className={"rSideMiddle"}>
                            {
                                parse(getPizzaSplits(special, []).join(""))
                            }
                        </span>

                        <span className={"bold lSideSmall"}>
                            {`₪ ${getPizzaAddonsPrice(special, 0)}` + " +"}
                        </span>
                    </div>

                )

            }


        })
        : ""
    return totBk;
}

const clearOrd = () => {
    let ord = { restId: "", currentP: [], Orders: [] };

    let stringOrd = JSON.stringify({ ...ord });
    sessionStorage.setItem("am_order", stringOrd)

    // מונה כשלי CARDCOM 520 חי כל עוד ההזמנה חיה - הזמנה חדשה מתחילה נקי
    sessionStorage.removeItem("am_cardcom520Fails");

    return (ord);

}

// קורא את הסל ישירות מהאחסון ולא מתוך ה-state.
// בתוך פונקציה אסינכרונית משתנה ה-order מה-closure עלול להיות לא מעודכן,
// וזו בדיוק הסיבה שההגנה מפני סל מעורב פספסה בעבר.
const readStoredOrder = () => {
    try {
        const raw = sessionStorage.getItem("am_order");
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

// האם בסל יש מוצרים של עסק אחר מזה שהלקוח נמצא בו כרגע.
// זה המצב שיוצר הזמנה עם מוצרים משני עסקים.
const cartBelongsToOtherRest = (theOrder, restId) => {
    if (!theOrder || !restId) return false;
    const hasItems = Array.isArray(theOrder.Orders) && theOrder.Orders.length > 0;
    return hasItems && !!theOrder.restId && theOrder.restId !== restId;
}

//מושך את חלוקת הפיצה לפי התוספות שנבחרו
const getPizzaSplits = (ord, rowsDisp) => {

    let lHalf = [];
    let rHalf = [];
    let rtQuart = [];
    let rbQuart = [];
    let ltQuart = [];
    let lbQuart = [];
    let full = [];

    for (let i = 0; i < ord.spec.length; i++) {

        if (ord.spec[i].splitSelected != null) {
            const getSPl = {
                lHalf: () => lHalf.push(ord.spec[i].servType),
                rHalf: () => rHalf.push(ord.spec[i].servType),
                rtQuart: () => rtQuart.push(ord.spec[i].servType),
                rbQuart: () => rbQuart.push(ord.spec[i].servType),
                ltQuart: () => ltQuart.push(ord.spec[i].servType),
                lbQuart: () => lbQuart.push(ord.spec[i].servType),
                full: () => full.push(ord.spec[i].servType)
            }

            getSPl[ord.spec[i].splitSelected]();
        }
    }

    //פונקציה פנימית
    const pushNewString = (placeTxt, arrySplt) => {
        rowsDisp.push(`<span class="headORdTxt">
        <span class="regular bold">
        ${placeTxt}
         </span>
            ${arrySplt.join(" + ")}
        <span/><br/>`);
    }

    if (full.length > 0) { pushNewString("כל המגש", full); }
    if (rHalf.length > 0) { pushNewString("חצי ימין", rHalf) }
    if (rtQuart.length > 0) { pushNewString("רבע ימין עליון", rtQuart) }
    if (rbQuart.length > 0) { pushNewString("רבע ימין תחתון", rbQuart) }
    if (lHalf.length > 0) { pushNewString("חצי שמאל", lHalf) }
    if (ltQuart.length > 0) { pushNewString("רבע שמאלי עליון", ltQuart) }
    if (lbQuart.length > 0) { pushNewString("רבע שמאלי תחתון", lbQuart) }


    return (rowsDisp)
}

//תוכן חלוקת המגש - בפיצריות
const pizzConten = (spec, item) => {

    if (spec.splitSelected != null) {

        let bk = "";
        if (spec.splitSelected != null) {
            const getSPl = {
                lHalf: "חצי שמאל",
                rHalf: "חצי ימין",
                rtQuart: "רבע ימין עליון",
                rbQuart: "רבע ימין תחתון",
                ltQuart: "רבע שמאל עליון",
                lbQuart: "רבע שמאל תחתון",
                full: "כל המגש"
            }

            bk = getSPl[spec.splitSelected];
        }
        else {
            bk = "כל המגש";
        }
        return (<span className={"regular"}>{bk}</span>)
    }
    else {
        return (<span className={"regular"}>{spec.itmsMount > 0 ? `X ${spec.itmsMount} ` : ""}</span>)
    }

}


//בודק אם יש רטבים מוצמדים ואם הלקוח עבר את המכסה החינמית
//במידה ועבר, יוחזר ההפרש שיש לתשלום 
const getStickedSauces = (theOrder) => {
    let priceToAdd = 0;
    let fSauces = (theOrder.freeSaucess != null) ? theOrder.freeSaucess : 0;
    let countIt = 0;
    theOrder.StickedSauces?.forEach(sauce => {

        for (let i = 0; i < sauce.mount; i++) {
            countIt++;
            if (countIt > fSauces) {
                priceToAdd += parseFloat((sauce.addToPrice != "") ? sauce.addToPrice : 0);
            }
        }

    });

    return priceToAdd;

}



//אופן תשלום
const payingTYpe = (payt) => {

    switch (payt) {
        case "1":
            return "אשראי";
        case "2":
            return "מזומן";
        case "3":
            return "ביט";
    }
}

//טקסט טווח ההגעה להזמנה עתידית - "בין X ל-Y", לפי הערוץ וזמן ההכנה/משלוח שלו.
//טווח לשני הערוצים (לא רק משלוח) - העסק עלול להתעכב גם באיסוף.
const futureArrivalRangeText = (channel, scheduledTime, prepMinutes) => {
    if (!scheduledTime) return "";
    const startTxt = scheduledTime.getHours().toString().padStart(2, "0") + ":" +
        scheduledTime.getMinutes().toString().padStart(2, "0");
    const endDate = new Date(scheduledTime.getTime() + (parseInt(prepMinutes) || 0) * 60 * 1000);
    const endTxt = endDate.getHours().toString().padStart(2, "0") + ":" +
        endDate.getMinutes().toString().padStart(2, "0");
    return channel === "Deliver"
        ? `המשלוח מתוכנן להגיע בין ${startTxt} ל-${endTxt}`
        : `מתוכנן לאיסוף בין ${startTxt} ל-${endTxt}`;
}

//הסטטוסים "בקשה לביטול"/"בקשה לסגירה" הם ניסוח פנימי-ניהולי (ר' CLAUDE.md) -
//ללקוח מוצגת תווית ידידותית במקומם; לכל שאר הסטטוסים מוחזר הערך המקורי כמות שהוא
const getClientFriendlyStatus = (orderStatus) => {
    const friendlyLabels = {
        "בקשה לביטול": "בטיפול מול העסק",
        "בקשה לסגירה": "התקבל, מעדכנים",
    };

    return friendlyLabels[orderStatus] || orderStatus;
}

export default {
    getOrderTotalPrice, getOrderToPay, getOrderPrice,
    takeAwayBlock, takeAwayBlock2, deliveryBlock2, deliveryBlock, clearOrd,
    readStoredOrder, cartBelongsToOtherRest, getStickedSauces,
    pizzConten,
    theItemSpecials,
    getPizzaPriceAfterFree,
    getPriceAfterFree,
    payingTYpe,
    getPizzaSplits,
    futureArrivalRangeText,
    getClientFriendlyStatus


};